import type { FaireProductEntity } from "../../entity_types/product";

export const p_p2g4pkkfxs: FaireProductEntity = {
  token: "p_p2g4pkkfxs",
  type: "product",
  name: "Coffee & Teacup Charms",
  brandToken: "b_h93v6v8mbm",
  brandName: "Aurora Boheme",
  imageUrl:
    "https://cdn.faire.com/fastly/40bd273efc29fbff14dce9745d15a7c1acc7a7c8239ff1f5457e747352b07d06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe9191925aca69277fa2e8f02551ee45ff23aaa52cef36ef24f1fb9ec67b4fe5.jpeg",
    "https://cdn.faire.com/fastly/fd18a17e2edbeebd8b94980f095a77b8063270886a03388288ee57816d84d728.jpeg",
  ],
  priceDollars: 20.79,
  description: "",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:25.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
